// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"77748f8a","195":"55ae179e","551":"bce718d2","671":"52b34ec0","867":"0d790ce0"}[chunkId] + ".chunk.js";
};